import React from 'react';
import RecoveryPasswordComponent from '../common/login/RecoveryPassword';

class RecoveryPassword extends React.Component{
  render(){
    return <RecoveryPasswordComponent />
  }
}

export default RecoveryPassword;